








import app from "@/app";
import { SXCompany, SXSector } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WSectorCompanies extends BaseComponent {
	@Prop({ type: SXSector, required: true })
	sector!: SXSector;

	loading = false;

	get companies() {
		let x = this;
		return app.services.companies.select(undefined, function(item) {
			return item.sector_id === x.sector.id;
		});
	}

	created() {
		if (!this.companies.length) {
			let x = this,
				always = () => (x.loading = false);
			x.loading = true;

			app.services.companies.getAll(
				{
					filters: {
						[SXCompany.COL_SECTOR_ID]: x.sector.id
					}
				},
				always,
				always,
				false
			);
		}
	}
}
